/**
 * Sefer raporlarında bağlam metinleri (ADR 0157; ortağın 2026-11-02 notu): başlatılmamış sefer
 * uyarısı, bağlam çelişkisi, sıradaki rapor, erken Noon, kira yönlendirmesi ve sefere bağlanacak
 * raporlar. Ekran adları İngilizce; Türkçe ikinci dil.
 */

export const voyageContextEn = {
  notStarted: {
    text: 'Voyage not started: departure {{time}} LT ({{port}}) is not linked to a voyage.',
    more: '(+{{count}})',
    start: 'Start Voyage',
    link: 'Link to {{no}} ({{count}})',
    open: 'Open departure',
    officeNote: 'Based on the latest data received from the vessel.',
    request: 'Voyage Request',
  },
  mismatch: {
    text: "The vessel's last report ({{kind}} {{time}} LT) is {{where}}. This report will be written to {{target}}.",
    textUnlinked:
      "The vessel's last report ({{kind}} {{time}} LT) is {{where}}. This report will be saved without a voyage.",
    unlinked: 'without a voyage',
    inVoyage: 'in {{no}}',
    follow: "Open in the last report's context",
    stay: 'Continue here',
  },
  due: {
    title: 'Next Report',
    next: 'Next: {{kind}}',
    at: '{{local}} LT ({{utc}} UTC)',
    remaining: 'in {{hours}} h {{minutes}} min',
    late: '{{hours}} h {{minutes}} min late',
    or: 'or {{others}}',
    draft: 'Draft waiting: {{kind}} {{time}} LT',
    open: 'Open {{kind}}',
    none: 'No next report planned yet: it follows the Next Operation of the last report.',
    eta: 'ETA',
  },
  earlyNoon: {
    text: 'Noon report time is 12:00 LT. It is now {{now}} LT; if you save now, the report is dated {{now}} LT. Leaving without saving creates no record.',
    refreshed: 'Report time set to {{time}} LT.',
    draftEarly: 'This draft is dated before 12:00 LT.',
    draftText:
      'Noon report time is 12:00 LT. This draft is dated {{time}} LT; saving does not change its time. After 12:00 LT, "Set time to 12:00 LT" appears.',
    fix: 'Set time to 12:00 LT',
  },
  linkFirst: 'Link first ({{count}})',
  contextError: 'Form context (port calls, defects, form records) could not be read: {{error}}',
  charter: {
    noCp: 'No CP record covers this departure (based on the latest data on board). The office opens the CP record; charter analysis starts with the CP period. At delivery, enter the On Hire report.',
    matched: 'Matching CP record: {{name}}',
    onHire:
      'Chartered departure without a CP period or On Hire: enter On Hire at delivery (All Reports ▸ Add New Report).',
    missingTitle: 'Charter information from the vessel',
    missingDescription:
      'Chartered at departure, no CP record: the vessel reported "Chartered" but no CP period covers the departure. Open the CP record; the vessel does not create it.',
    newFrom: 'New CP from this departure',
    onHireDescription:
      'On Hire reports not linked to a CP: choose them as the delivery report in the CP record.',
  },
  reportsToLink: {
    title: 'Reports to Link',
    description:
      'Reports without a voyage that start this voyage, in date order. They are linked in the same save; untick to leave one out.',
    descriptionOffice:
      'Reports without a voyage that start this voyage, in date order. The selected reports are added to the voyage request; they are linked when the vessel approves it. Untick to leave one out.',
    none: 'No reports without a voyage to link.',
  },
  departureMissing:
    'The departure for this voyage could not be read ({{error}}). Saving is blocked so that the voyage does not open without its departure.',
  suggestionsError: 'Suggested reports could not be read: {{error}}',
  otherUnlinked: 'Other reports without a voyage',
};

export const voyageContextTr: typeof voyageContextEn = {
  notStarted: {
    text: 'Sefer başlatılmadı: Kalkış {{time}} LT ({{port}}) sefere bağlı değil.',
    more: '(+{{count}})',
    start: 'Seferi Başlat',
    link: "{{no}}'e bağla ({{count}})",
    open: 'Kalkışı aç',
    officeNote: 'Gemiden son alınan bilgiye göre.',
    request: 'Sefer Talebi',
  },
  mismatch: {
    text: "Geminin son raporu ({{kind}} {{time}} LT) {{where}}. Bu rapor {{target}}'e yazılacak.",
    textUnlinked:
      'Geminin son raporu ({{kind}} {{time}} LT) {{where}}. Bu rapor sefersiz kaydedilecek.',
    unlinked: 'sefersiz',
    inVoyage: '{{no}} seferinde',
    follow: 'Son raporun bağlamında aç',
    stay: 'Bu seferde devam et',
  },
  due: {
    title: 'Sonraki Rapor',
    next: 'Sıradaki: {{kind}}',
    at: '{{local}} LT ({{utc}} UTC)',
    remaining: '{{hours}} sa {{minutes}} dk sonra',
    late: '{{hours}} sa {{minutes}} dk gecikti',
    or: 'ya da {{others}}',
    draft: 'Taslak bekliyor: {{kind}} {{time}} LT',
    open: '{{kind}} aç',
    none: 'Sıradaki rapor henüz yok: son raporun Sonraki İşlem seçiminden gelir.',
    eta: 'ETA',
  },
  earlyNoon: {
    text: 'Öğle raporu saati 12:00 LT. Şu an {{now}} LT; şimdi kaydederseniz rapor {{now}} LT tarihli olur. Kaydetmeden çıkarsanız kayıt oluşmaz.',
    refreshed: 'Rapor saati {{time}} LT olarak alındı.',
    draftEarly: "Bu taslak 12:00 LT'den önce tarihli.",
    draftText:
      'Öğle raporu saati 12:00 LT. Bu taslak {{time}} LT tarihli; kaydetmek saatini değiştirmez. 12:00 LT\'den sonra "Saati 12:00 LT yap" seçeneği çıkar.',
    fix: 'Saati 12:00 LT yap',
  },
  linkFirst: 'Önce bağla ({{count}})',
  contextError: 'Form bağlamı (liman ziyaretleri, arızalar, form kayıtları) okunamadı: {{error}}',
  charter: {
    noCp: 'Bu gemi için kalkışı kapsayan CP kaydı yok (gemideki son bilgiye göre). CP kaydını ofis açar; kira analizi CP dönemiyle başlar. Teslim anında Kiraya Giriş (On Hire) raporunu girin.',
    matched: 'Eşleşen CP kaydı: {{name}}',
    onHire:
      'Kiralı kalkış, CP dönemi ve Kiraya Giriş yok: teslim anında Kiraya Giriş (On Hire) raporunu girin (All Reports ▸ Add New Report).',
    missingTitle: 'Gemiden gelen kira bilgisi',
    missingDescription:
      'Kalkışta kira bildirildi, CP kaydı yok: gemi "Kiralı" dedi ama kalkışı kapsayan CP dönemi yok. CP kaydını açın; gemi açmaz.',
    newFrom: 'Bu kalkıştan yeni CP',
    onHireDescription:
      "CP'ye bağlı olmayan Kiraya Giriş (On Hire) raporları: CP kaydında teslim raporu olarak seçin.",
  },
  reportsToLink: {
    title: 'Bağlanacak Raporlar',
    description:
      'Bu seferi başlatan sefersiz raporlar, tarih sırasıyla. Aynı kayıtta bağlanır; dışarıda bırakmak için işareti kaldırın.',
    descriptionOffice:
      'Bu seferi başlatan sefersiz raporlar, tarih sırasıyla. Seçili raporlar sefer talebine eklenir; gemi onaylayınca bağlanır. Dışarıda bırakmak için işareti kaldırın.',
    none: 'Bağlanacak sefersiz rapor yok.',
  },
  departureMissing:
    'Bu seferin kalkışı okunamadı ({{error}}). Sefer kalkışsız açılmasın diye kayıt engellendi.',
  suggestionsError: 'Önerilen raporlar okunamadı: {{error}}',
  otherUnlinked: 'Diğer sefersiz raporlar',
};
